<template>
    <header class="client-header"><h1>JS Company</h1></header>
</template>
<script>
export default {};
</script>
<style scoped>
.client-header {
    display: none;
    justify-content: center;
    align-items: center;
    height: 5rem;
    box-sizing: border-box;
    border-bottom: 2px solid coral;
}
</style>
